import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function SandSaltContainerePage() {
  const databladPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-salt-sand-container.pdf';
  const vedligeholdPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/vedligehold-overflader.pdf';

  return (
    <>
      <SeoHead
        title="Sand-salt containere - RB Glasfiber A/S"
        description="Download datablad. Med vores sandcontainer er du klar til vinteren. Containeren er fremstillet i håndoplagt glasfiber, som er yderst slagfast og vedligeholdelsesfri. Størrelser fra 200 l til 800 l."
        canonical="https://www.rb-glasfiber.dk/produkter/sand-salt-containere"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-sand-salt-containere-cropresize-500x500.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-sand-salt-containere-cropresize-500x500.webp', 'width=1600,quality=80,format=auto')}
            alt="Sand-salt containere"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-snowflake"></i>
              <span>Vinterberedskab & Glatførebekæmpelse</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-4">
              Sand-salt containere
            </h1>
            <p className="text-xl text-[#22c55e] font-semibold mb-6">
              200 - 400 - 600 - 800 liter
            </p>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Med vores sandcontainer er du klar til vinteren. Containeren er fremstillet i håndoplagt glasfiber, som er yderst slagfast og vedligeholdelsesfri.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={databladPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-sm shadow transition-all"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Download datablad (PDF)</span>
              </a>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-all"
              >
                <span>Forespørg pris & levering</span>
                <i className="fa-solid fa-arrow-right text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Klar til vinteren
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Yderst slagfast og vedligeholdelsesfri
              </h2>
              <div className="prose text-slate-700 text-base leading-relaxed space-y-4">
                <p>
                  Med vores sandcontainer er du klar til vinteren. Containeren er fremstillet i håndoplagt glasfiber, som er yderst slagfast og vedligeholdelsesfri.
                </p>
                <p>
                  Containeren kan leveres i størrelse fra 200 l til 800 l og kan forsynes med indstøbt tekst i låget eller med påmalet tekst på kroppen.
                </p>
              </div>

              {/* Teknisk data */}
              <div className="p-6 rounded-lg bg-slate-50 border border-slate-200">
                <h3 className="font-bold text-slate-900 uppercase text-sm mb-3">Teknisk data</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 text-sm text-slate-700">
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Fremstillet i håndoplagt glasfiber</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Kan leveres med låsebeslag</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Forstærket på alle udsatte steder</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>800 l med galvaniseret jernramme</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Farve efter ønske</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Kan leveres med frontudtag</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Størrelse 200 – 400 – 600 – 800 l</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Yderst vejrbestandig og slagfast</span></li>
                </ul>
              </div>

              <div className="pt-2">
                <a
                  href={vedligeholdPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs font-semibold text-slate-600 hover:text-[#1e9457]"
                >
                  <i className="fa-solid fa-file-pdf"></i>
                  <span>Læs vejledning i vedligehold af gel-coat overflader (PDF)</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-square bg-slate-900 max-w-md mx-auto">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-sand-salt-containere-cropresize-500x500.webp', 'width=600,quality=85,format=auto')}
                  alt="Sand-salt containere i glasfiber"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Lightbox Gallery */}
          <div className="pt-8 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="standardprodukter"
              title="Fotogalleri: Sand- og saltcontainere"
              description="Billeder af sandcontainere til vintervedligeholdelse."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
